// extracted by mini-css-extract-plugin
export default {"pdfContainer":"NbAU1iXAbwsv4Ay7AgxA","pdfIcon":"xbMcIvQkbV_tbqNSU3qA","pdfNameLink":"a5l2m1xfhuVzHgbn9ppx","closeIcon":"jo5PsGFFPYaQxqMbkxRx"};